import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

export const PrivateRoute = ({ component: Component, roles, ...rest }) => {
    let currentUser = useSelector(state => state.users.currentUser);
    return (
        <Route
            {...rest}
            render={props => {
                if (!currentUser) {
                    return (
                        <Redirect
                            to={{
                                pathname: "/",
                                state: { from: props.location },
                            }}
                        />
                    );
                }

                return currentUser &&
                    roles &&
                    roles.indexOf(currentUser.role) === -1 ? (
                    <Redirect to={{ pathname: "/unauthorized" }} />
                ) : (
                    <Component {...props} />
                );
            }}
        />
    );
};
